module.exports = __webpack_public_path__ + "static/media/cc-1.5ed774cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/cc-1.png
// module id = 100
// module chunks = 0